<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown-custom
                class="gradient-dropdown"
                :value="value"
                :options="options"
                @input="onInput"
            >
                <template v-slot="slotProps">
                    <div v-if="slotProps.value" class="gradient-dropdown__preview" :style="addTransparencyCheckerboardStyles(slotProps.value)" />
                    <div v-else class="gradient-dropdown__empty" />
                </template>
            </dropdown-custom>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import { gradientStyleByName } from '@/utils/css';
import checkerboardPattern from '@/assets/ui/checkerboard-pattern.png';

export default {
    name: 'background-gradient',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Background Gradient',
            gradientStyleByName,
            value: '',
        };
    },

    computed: {
        options() {
            const noneOption = [{ text: 'None', value: '' }];
            const gradientOptions = this.settings.gradients.map(gradient => ({ text: gradient.displayName, value: gradient.name }));

            return noneOption.concat(gradientOptions);
        },
    },

    methods: {
        onInput(valueNew) {
            this.value = valueNew;

            this.selectedElements.forEach((selectedElem) => {
                selectedElem.setElementData('gradient', this.value);
            });

            this.onOptionChange(this.value);
        },

        onSelectedElement() {
            this.value = this.selectedElements[0].getElementData('gradient') || '';
        },

        addTransparencyCheckerboardStyles(value) {
            const appendedCheckerboardStyles = gradientStyleByName(value);
            appendedCheckerboardStyles['background-image'] += `, url('${ checkerboardPattern }')`;
            appendedCheckerboardStyles['background-repeat'] = 'repeat';

            return appendedCheckerboardStyles;
        },
    },
};
</script>

<style lang="scss">
.gradient-dropdown {
    $this: &;
    padding: 0;

    &__preview {
        min-height: 35px;
        width: 100%;
    }

    &__empty {
        min-height: 35px;
        width: 100%;
        background-color: var(--form-inputBackgroundColor);
        border: 1px solid var(--form-inputBorderColor);
    }
}
</style>
